export interface PagesConfigState {
    loading: boolean;
    mainPageText: string;
}

export enum PagesConfigActionType {
    START_REQUEST = "START_REQUEST",
    MAIN_PAGE_TEXT_LOADED = "MAIN_PAGE_TEXT_LOADED",
    FINISH_REQUEST = "FINISH_REQUEST",
}